import React from 'react'
import Home from './Home'
import Help from './Help'
import About from './About'
import Work from './Working'
import Contact from './Contact'

function HomePage() {
  return (
    <div>
        <Home/>
        <Help/>
        <About/>
        <Work/>
        <Contact/>
    </div>
  )
}

export default HomePage